import { Helmet } from 'react-helmet-async'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
import { useBlogArticleListQuery, useFeatureFlag } from '@mwxltd/flix-api-client'
import { useListAdInsertion } from '@flix/common/domain/ads/listAdInsertion/useListAdInsertion'
import { CloseUpArticlesList } from '@flix/common/domain/blog/close-up/CloseUpArticlesList'
import { blogTypes } from '@flix/common/domain/blog/getters'
import { MaxWidthView } from '@flix/common/elements/layout'
import { ComponentError, ComponentPlaceholder } from '@flix/common/elements/status'
import statusMsgs from '@flix/common/elements/status/messages'
import { canonicalUrl } from '../../../utils/htmlHead'
import meta from '../../metaDescriptions'

const CloseUpListPage = () => {
  const { getFlagValue } = useFeatureFlag()
  const bannerAdsEnabled = getFlagValue('bannerAdsEnabled')

  const intl = useIntl()
  const location = useLocation()
  const { loading, error, onFetchMore, data } = useBlogArticleListQuery({
    blog: blogTypes.CLOSE_UP,
  })

  const articles = useListAdInsertion({ list: data?.articles, skip: bannerAdsEnabled })

  if (loading && !data?.articles.items.length) {
    return <ComponentPlaceholder activityIndicator height={640} />
  }
  if (error) {
    return <ComponentError {...statusMsgs.listLoadError} height={640} />
  }

  return (
    <>
      <Helmet>
        <title>Close-Up | Flix Premiere</title>
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Close-Up | Flix Premiere" />
        <meta
          name="description"
          property="og:description"
          content={intl.formatMessage(meta.closeUp)}
        />
        <meta property="og:url" content={canonicalUrl(location)} />
        <link rel="canonical" href={canonicalUrl(location)} />
      </Helmet>

      <MaxWidthView>
        <CloseUpArticlesList
          refreshing={loading}
          onEndReached={onFetchMore}
          articles={articles.items}
        />
      </MaxWidthView>
    </>
  )
}

export default CloseUpListPage
